import React, { Component } from 'react'
import { connect } from 'react-redux'
import uuid from 'uuid/v4'

import Menu from '../../config/menu'
import MenuItem from './menu/Item'
import SingleItem from './menu/SingleItem'

class Sidebar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menu: null
    }
  }
  componentDidMount () {
    var endpoints = []
    this.props.configReducer.endpoints.map(endpoint => {
      return Object.assign(endpoints, {[endpoint.name]: endpoint})
    })
    this.setState({menu: Menu.getMenu(endpoints)})
  }
  render () {
    if (!this.state.menu) return false
    return (
      <aside className='sidebar'>
        {this.state.menu.map((item) => {
          if (item.single) return (<SingleItem admin={item.admin} key={uuid()} icon={item.icon} title={item.title} location={item.location} enable={item.enable} />)
          return (
            <MenuItem
              admin={item.admin}
              key={uuid()}
              icon={item.icon}
              title={item.title}
              children={item.children} />)
        })}
      </aside>
    )
  }
}
// eslint-disable-next-line
Sidebar = connect(state => state)(Sidebar)
export default Sidebar



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/Sidebar.js